import { gql, TypedDocumentNode } from '@apollo/client';

type EnrollMutationInput = {
  data: {
    type: 'users';
    attributes: {
      country_code: string;
      enroll_to_loyalty: boolean;
      order_id: string | undefined;
    };
    id: string;
  };
};

export type EnrollMutationVariables = {
  id: string;
  input: EnrollMutationInput;
};

export type EnrollMutation = {
  __typename: 'RestEnrollPayload';
};

export const ENROLL_MUTATION: TypedDocumentNode<EnrollMutation, EnrollMutationVariables> = gql`
  mutation EnrollMutation($id: String!, $input: EnrollMutationInput!) {
    enroll(id: $id, input: $input)
      @rest(
        type: "RestEnrollPayload"
        endpoint: "moda"
        path: "/v3.5/users/{args.id}"
        method: "PATCH"
      ) {
      NoResponse
    }
  }
`;
